import { JobseekerModel } from '../shared/models/jobseeker-model';
import { Component, Input, OnInit, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'hr-jobseeker-uploaded-document-info',
  templateUrl: './jobseeker-uploaded-document-info.component.html',
  styleUrls: ['./jobseeker-uploaded-document-info.component.less'],
  standalone: false,
})
export class JobseekerUploadedDocumentInfoComponent implements OnInit {
  @Input()
  public jobseeker: JobseekerModel;

  @Output()
  public onUpdate: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor() {}

  public onDelete() {
    this.onUpdate.emit(true);
  }

  ngOnInit() {}
}
